import { NgModule }                          from '@angular/core';
import { UIRouterUpgradeModule }             from '@uirouter/angular-hybrid';

import { HaynesProAddLaborTimesComponent }                           from './haynes-pro.add-labor-times.component';
import { HaynesProDiagnosticToolAdjustmentsComponent }               from './diagnostic-tool/haynes-pro.diagnostic-tool.adjustments.component';
import { HaynesProDiagnosticToolComponent }                          from './diagnostic-tool/haynes-pro.diagnostic-tool.component';
import { HaynesProDiagnosticToolDiagnosticDetailsComponent }         from './diagnostic-tool/haynes-pro.diagnostic-tool.diagnostic-details.component';
import { HaynesProDiagnosticToolElectronicLocationDetailsComponent } from './diagnostic-tool/haynes-pro.diagnostic-tool.electronic-location-details.component';
import { HaynesProDiagnosticToolElectronicLocationsComponent }       from './diagnostic-tool/haynes-pro.diagnostic-tool.electronic-locations.component';
import { HaynesProDiagnosticToolFuseLocationsComponent }             from './diagnostic-tool/haynes-pro.diagnostic-tool.fuse-locations.component';
import { HaynesProDiagnosticToolLocationsComponent }                 from './diagnostic-tool/haynes-pro.diagnostic-tool.locations.component';
import { HaynesProDiagnosticToolLubricantsComponent }                from './diagnostic-tool/haynes-pro.diagnostic-tool.lubricants.component';
import { HaynesProDiagnosticToolRepairDetailsComponent }             from './diagnostic-tool/haynes-pro.diagnostic-tool.repair-details.component';
import { HaynesProDiagnosticToolRepairManualsComponent }             from './diagnostic-tool/haynes-pro.diagnostic-tool.repair-manuals.component';
import { HaynesProDiagnosticToolSectionComponent }                   from './diagnostic-tool/haynes-pro.diagnostic-tool.section.component';
import { HaynesProDiagnosticToolSmartPackComponent }                 from './diagnostic-tool/haynes-pro.diagnostic-tool.smart-pack.component';
import { HaynesProDiagnosticToolSmartpackDetailsComponent }          from './diagnostic-tool/haynes-pro.diagnostic-tool.smart-pack-details.component';
import { HaynesProDiagnosticToolTechnicalDrawingsComponent }         from './diagnostic-tool/haynes-pro.diagnostic-tool.technical-drawings.component';
import { HaynesProDiagnosticToolVesaComfortWiringDiagramComponent }  from './diagnostic-tool/vesa/comfort-wiring-diagram/haynes-pro.diagnostic-tool.vesa-comfort-wiring-diagram.component';
import { HaynesProDiagnosticToolVesaComponent }                      from './diagnostic-tool/vesa/haynes-pro.diagnostic-tool.vesa.component';
import { HaynesProDiagnosticToolVesaComponentDetailComponent }       from './diagnostic-tool/vesa/component-detail/haynes-pro.diagnostic-tool.vesa-component-detail.component';
import { HaynesProDiagnosticToolVesaComponentInfoComponent }         from './diagnostic-tool/vesa/component-info/haynes-pro.diagnostic-tool.vesa-component-info.component';
import { HaynesProDiagnosticToolVesaComponentLocationComponent }     from './diagnostic-tool/vesa/location/haynes-pro.diagnostic-tool.vesa-component-location.component';
import { HaynesProDiagnosticToolVesaComponentRelatedPartsComponent } from './diagnostic-tool/vesa/related-parts/haynes-pro.diagnostic-tool.vesa-component-related-parts.component';
import { HaynesProDiagnosticToolVesaComponentsComponent }            from './diagnostic-tool/vesa/components/haynes-pro.diagnostic-tool.vesa-components.component';
import { HaynesProDiagnosticToolVesaEcuPinConnectorComponent }       from './diagnostic-tool/vesa/ecu-pin-connector/haynes-pro.diagnostic-tool.vesa-ecu-pin-connector.component';
import { HaynesProDiagnosticToolVesaWiringDiagramComponent }         from './diagnostic-tool/vesa/wiring-diagram/haynes-pro.diagnostic-tool.vesa-wiring-diagram.component';
import { HaynesProDiagnosticToolVesaDetailsComponent }               from './diagnostic-tool/vesa/haynes-pro.diagnostic-tool.vesa-details.component';
import { HaynesProDiagnosticToolVesaFaultCodesComponent }            from './diagnostic-tool/vesa/fault-codes/haynes-pro.diagnostic-tool.vesa-fault-codes.component';
import { HaynesProDiagnosticToolVesaFaultCodesExpandedRowComponent } from './diagnostic-tool/vesa/fault-codes/haynes-pro.diagnostic-tool.vesa-fault-codes.expanded-row.component';
import { HaynesProDiagnosticToolVesaNetworksComponent }              from './diagnostic-tool/vesa/networks/haynes-pro.diagnostic-tool.vesa-networks.component';
import { HaynesProDiagnosticToolWarningLightsComponent }             from './diagnostic-tool/haynes-pro.diagnostic-tool.warning-lights.component';
import { HaynesProLaborTimesComponent }                              from './haynes-pro.labor-times.component';
import { HaynesProLookupSettingsComponent }                          from './haynes-pro.lookup.settings.component';
import { HaynesProMaintenanceTimesComponent }                        from './haynes-pro.maintenance-times.component';
import { HaynesProMaintenanceTimesExpandedRowComponent }             from './haynes-pro.maintenance-times.row.expanded.component';
import { HaynesProMaintenanceTimesExtraDataExpandedRowComponent }    from './haynes-pro.maintenance-times.extra-data.row.expanded.component';
import { HaynesProPurchaseLookupsComponent }                         from './haynes-pro.purchase-lookups.component';
import { HaynesProRepairTimesComponent }                             from './haynes-pro.repair-times.component';
import { HaynesProService }                                          from './haynes-pro.service';
import { HaynesProSettingsComponent }                                from './haynes-pro.settings.component';
import { HaynesProStates }                                           from './haynes-pro.states';
import { HaynesProTechnicalDrawingsViewerComponent }                 from './diagnostic-tool/haynes-pro.technical-drawings-viewer.component';
import { HaynesProSubscriptionSettingsComponent }                    from './haynes-pro.subscription.settings.component';
import { HaynesProVehicleSelectionComponent }                        from './haynes-pro.vehicle-selection.component';
import { SharedModule }                                              from '../shared/shared.module';
import { TableModule }                                               from '../table/table.module';

@NgModule({
  declarations: [
    HaynesProAddLaborTimesComponent,
    HaynesProLaborTimesComponent,
    HaynesProLookupSettingsComponent,
    HaynesProMaintenanceTimesComponent,
    HaynesProPurchaseLookupsComponent,
    HaynesProRepairTimesComponent,
    HaynesProSettingsComponent,
    HaynesProSubscriptionSettingsComponent,
    HaynesProVehicleSelectionComponent,
    HaynesProDiagnosticToolAdjustmentsComponent,
    HaynesProDiagnosticToolComponent,
    HaynesProDiagnosticToolDiagnosticDetailsComponent,
    HaynesProDiagnosticToolElectronicLocationDetailsComponent,
    HaynesProDiagnosticToolElectronicLocationsComponent,
    HaynesProDiagnosticToolFuseLocationsComponent,
    HaynesProDiagnosticToolLubricantsComponent,
    HaynesProDiagnosticToolLocationsComponent,
    HaynesProDiagnosticToolRepairManualsComponent,
    HaynesProDiagnosticToolRepairDetailsComponent,
    HaynesProDiagnosticToolSectionComponent,
    HaynesProDiagnosticToolSmartPackComponent,
    HaynesProDiagnosticToolSmartpackDetailsComponent,
    HaynesProDiagnosticToolTechnicalDrawingsComponent,
    HaynesProDiagnosticToolVesaComfortWiringDiagramComponent,
    HaynesProDiagnosticToolVesaComponent,
    HaynesProDiagnosticToolVesaComponentDetailComponent,
    HaynesProDiagnosticToolVesaComponentInfoComponent,
    HaynesProDiagnosticToolVesaComponentLocationComponent,
    HaynesProDiagnosticToolVesaComponentRelatedPartsComponent,
    HaynesProDiagnosticToolVesaComponentsComponent,
    HaynesProDiagnosticToolVesaDetailsComponent,
    HaynesProDiagnosticToolVesaEcuPinConnectorComponent,
    HaynesProDiagnosticToolVesaFaultCodesComponent,
    HaynesProDiagnosticToolVesaFaultCodesExpandedRowComponent,
    HaynesProDiagnosticToolVesaNetworksComponent,
    HaynesProDiagnosticToolVesaWiringDiagramComponent,
    HaynesProDiagnosticToolWarningLightsComponent,
    HaynesProMaintenanceTimesExpandedRowComponent,
    HaynesProMaintenanceTimesExtraDataExpandedRowComponent,
    HaynesProTechnicalDrawingsViewerComponent
  ],
  entryComponents: [
    HaynesProAddLaborTimesComponent,
    HaynesProLaborTimesComponent,
    HaynesProLookupSettingsComponent,
    HaynesProMaintenanceTimesComponent,
    HaynesProPurchaseLookupsComponent,
    HaynesProRepairTimesComponent,
    HaynesProSettingsComponent,
    HaynesProSubscriptionSettingsComponent,
    HaynesProVehicleSelectionComponent,
    HaynesProDiagnosticToolAdjustmentsComponent,
    HaynesProDiagnosticToolComponent,
    HaynesProDiagnosticToolDiagnosticDetailsComponent,
    HaynesProDiagnosticToolElectronicLocationDetailsComponent,
    HaynesProDiagnosticToolElectronicLocationsComponent,
    HaynesProDiagnosticToolFuseLocationsComponent,
    HaynesProDiagnosticToolLubricantsComponent,
    HaynesProDiagnosticToolLocationsComponent,
    HaynesProDiagnosticToolRepairManualsComponent,
    HaynesProDiagnosticToolRepairDetailsComponent,
    HaynesProDiagnosticToolSectionComponent,
    HaynesProDiagnosticToolSmartPackComponent,
    HaynesProDiagnosticToolSmartpackDetailsComponent,
    HaynesProDiagnosticToolTechnicalDrawingsComponent,
    HaynesProDiagnosticToolVesaComfortWiringDiagramComponent,
    HaynesProDiagnosticToolVesaComponent,
    HaynesProDiagnosticToolVesaComponentDetailComponent,
    HaynesProDiagnosticToolVesaComponentInfoComponent,
    HaynesProDiagnosticToolVesaComponentLocationComponent,
    HaynesProDiagnosticToolVesaComponentRelatedPartsComponent,
    HaynesProDiagnosticToolVesaComponentsComponent,
    HaynesProDiagnosticToolVesaDetailsComponent,
    HaynesProDiagnosticToolVesaEcuPinConnectorComponent,
    HaynesProDiagnosticToolVesaFaultCodesComponent,
    HaynesProDiagnosticToolVesaFaultCodesExpandedRowComponent,
    HaynesProDiagnosticToolVesaNetworksComponent,
    HaynesProDiagnosticToolVesaWiringDiagramComponent,
    HaynesProDiagnosticToolWarningLightsComponent,
    HaynesProMaintenanceTimesExpandedRowComponent,
    HaynesProMaintenanceTimesExtraDataExpandedRowComponent,
    HaynesProTechnicalDrawingsViewerComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    UIRouterUpgradeModule.forChild({ states: HaynesProStates })
  ],
  providers: [
    HaynesProService
  ]
})
export class HaynesProModule {}
